import React, { useState, useEffect } from 'react';
import { Button } from 'primereact/button';
import {InputSwitch} from 'primereact/inputswitch';
import { Message } from 'primereact/message';
import {DataTable} from 'primereact/datatable';
import {Column} from 'primereact/column';
import {Toolbar} from 'primereact/toolbar';
import {Card} from 'primereact/card';
import { useHistory, Link } from "react-router-dom";
import loader from '../loader';
import { ProgressSpinner } from 'primereact/progressspinner';
import Session from '../auth/Session';

const serverUrl = process.env.REACT_APP_SERVER_URL || '';
const baseUrl = process.env.REACT_APP_PUBLIC_URL || 'http://localhost:3000';

function CreateForm() {

  let [ items, setItems ] = useState([]);
  let [ display, setDisplay ] = useState('grid');
  
  let [ success, setSuccess ] = useState('');
  let [ loading, setLoading ] = useState(false);

  let logged = Session.getCookie();

  let history = useHistory();
  useEffect(() => {
    loader.get('/client/list', res => {
        setItems(res.items);
    }, setLoading);
  }, []);

  let updateItem = (data) => {
    const url = '/client/update';
    setSuccess(false);
    loader.post(url, data, res => {
        if (res.success) setSuccess(true);
    }, setLoading);
  };

  let deleteItem = (id) => {
    const url = '/client/delete/' + id;
    setSuccess(false);
    loader.get(url, res => {
        if (res.success) {
            setSuccess(true);
            items = items.filter(i => i.id !== id);
            setItems(items);
        }
    }, setLoading);
  };

  let toggleActive = (clients, id) => {
    let items = Object.assign([], clients);
    items = items.map(item => {
        if (item.id === id) {
            item.active = !item.active;
            updateItem({ id: item.id, active: item.active });
        }
        return item;
    });
    setItems(items);
  }

  let recordOptions = (item, column) => {
    const logged = Session.getCookie();
    return <div>
        <Button
            onClick={e => history.push({ pathname: '/backoffice/clients/view/' + item.id })} 
            type="button" 
            icon="pi pi-folder-open" 
            className="p-button-info"
        />
        <Button
            onClick={e => deleteItem(item.id)} 
            type="button" 
            icon="pi pi-times" 
            className="p-button-danger"
            disabled={![logged.role1].includes('ADMINISTRATOR')}
        />
    </div>;
  }

  let recordActive = (item, column) => {
    return <div>
        <InputSwitch 
            checked={item.active} 
            onChange={(e) => toggleActive(items, item.id)} 
        />
    </div>;
  }

  // Download
  const getFileUrl = (filename, folder) => {
    return filename ? serverUrl + '/download/' + folder + '/' + filename
        : '/assets/images/photo_placeholder.png';
  }

  let recordPhoto = (item, column) => {
    return (
        <img 
            src={getFileUrl(item.photo, 'clients')} 
            alt="Fotografia"
            title="Fotografia"
            className="img-avatar-mini"
        />
    )
  }

  const isMobile = window.innerWidth <= 768;
  if (loading) return <ProgressSpinner />;
  return (
    <React.Fragment>

        { ['ADMINISTRATOR', 'ORG_ADMIN', 'ADMIN'].includes(logged.role1) &&
            <div className="card card-w-title">
                <h1>Promova o Seu Negócio</h1>
                <p>Promova o seu negócio ao partilhar o link de registo de clientes</p>
                <p>
                    <input 
                        className="sharelink" 
                        onClick={e => { e.target.select(); document.execCommand("copy") }}
                        value={baseUrl + '/#/registar'}
                    />
                </p>
            </div>
        }

        <div className="card card-w-title">
            <h1>Clientes</h1>

            <Toolbar>
                <div className="p-toolbar-group-left">
                    <Link to="/backoffice/clients/form/0">
                        <Button label="Inserir Novo" />
                    </Link>
                </div>
                <div className="p-toolbar-group-right">
                    <InputSwitch 
                        label="Grelha"
                        checked={display === 'grid'} 
                        onChange={(e) => setDisplay(display === 'grid' ? 'list' : 'grid')} 
                    />{' '}Grelha
                </div>
            </Toolbar>

            { success && (
                <div className="p-grid">
                    <div className="p-col-12">

                        <Message 
                            severity="success" 
                            text="O cliente foi alterado com sucesso!">
                        </Message>
                        
                    </div>
                </div>
            ) }

            { display === 'grid' ? (
                <div className="p-grid">

                    { items.map(item => (
                        <div className="p-col-12 p-lg-2" key={item.id}>
                            <Card
                                header={(
                                    <Link to={'/backoffice/clients/view/' + item.id }>
                                        <img 
                                            src={getFileUrl(item.photo, 'clients')} 
                                            alt="Fotografia"
                                            title="Fotografia"
                                            className="img-avatar"
                                        />
                                    </Link>
                                )}>
                                { item.firstname } { item.lastname }
                            </Card>
                        </div>
                    )) }
                    
                </div>
            ) : (
                <div className="p-grid">
                    <div className="p-col-12">

                    <DataTable value={items}>
                        <Column 
                            header="Foto"
                            body={recordPhoto}
                        />
                        <Column 
                            header="Nome"
                            field="fullname"
                            sortable={true}
                            filter={true}
                            filterMatchMode="contains"
                        />
                        { !isMobile && (
                            <Column 
                                header="Activo"
                                body={recordActive}
                            />
                        ) }
                        <Column 
                            header="Opções"
                            body={recordOptions}
                            style={{ textAlign: 'right' }}
                            className="actions"
                        />
                    </DataTable>
                        
                    </div>
                </div>
            ) }
            
        </div>
    </React.Fragment>
  );

}

export default CreateForm;
